(function() {
  // Only execute the script if at least one element with the "gender-btn" class exists
  if (!document.querySelector('.gender-btn')) {
    return;
  }

  // References to the anchor elements and the content container
  const menLink = document.getElementById('men-btn');
  const womenLink = document.getElementById('women-btn');
  const swatchOptions = document.querySelector('.swatch[data-option-title*="size"] .swatch__options');
  const mensSizes = document.querySelectorAll('.mens-size');
  const womensSizes = document.querySelectorAll('.womens-size');

  // Function to update the tab state
  function updateTab(gender) {
    // Set the container background to the active color (#f5f5f5)
    swatchOptions.style.backgroundColor = '#f5f5f5';

    if (gender === 'men') {
      // Display men's sizes; hide women's sizes
      mensSizes.forEach(el => el.style.display = 'inline');
      womensSizes.forEach(el => el.style.display = 'none');
      // Update tab styles
      menLink.classList.add('selected');
      womenLink.classList.remove('selected');
    } else if (gender === 'women') {
      // Display women's sizes; hide men's sizes
      mensSizes.forEach(el => el.style.display = 'none');
      womensSizes.forEach(el => el.style.display = 'inline');
      // Update tab styles
      womenLink.classList.add('selected');
      menLink.classList.remove('selected');
    }
  }

  // Attach click event listeners to the anchor tags
  menLink.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default anchor behavior
    updateTab('men');
  });

  womenLink.addEventListener('click', function(e) {
    e.preventDefault();
    updateTab('women');
  });

  // Initialize with "Men" as the default selection
  updateTab('men');
})();